import React from "react";
import {connect} from "react-redux";
import PropTypes from "prop-types";
import {stateSelector as resultsSelector} from "../../ducks/results";
import Grid from "@material-ui/core/Grid";
import Result from "./Result";
import Container from "../Container";

function Results(props) {
  const {results} = props;
  return (
    <Grid container>
      <Container>
        <Grid item xs={12}>
          {results.map(({id, title, description, link, variant}) => (
            <Result
              key={id}
              id={id}
              variant={variant}
              title={title}
              description={description}
              link={link}
            />
          ))}
        </Grid>
      </Container>
    </Grid>
  );
}

Results.propTypes = {
  results: PropTypes.array
};

export default connect((state) => ({
  results: resultsSelector(state)
}))(Results);
